import * as React from 'react';
import { Translate } from 'react-localize-redux';

import bindAllOfThis from "src/utils/BindThisHelper"; // 'this' binder
import { NameOf } from 'src/utils/NameOf';
import { PageProps } from 'src/models/common/ComponentProps';

import ReportHeader from 'src/components/common/ReportHeader';
import DataTable, { DataTableButtonExport, DataTableColumnProps, Filterer } from 'src/components/common/DataTable';
import StudentActivityReportDTO from 'src/models/report/StudentActivityReportDTO';
import ReportRequestDTO from 'src/models/datatable/ReportRequestDTO';
import TableResponseDTO from 'src/models/datatable/TableResponseDTO';
import ReportApiController from 'src/api/ReportApiController';
import ReportHeaderDTO from 'src/models/report/ReportHeaderDTO';
import './AdminReports.less';
import { Icon } from 'antd';

interface StudentActivityDetailReportProps extends PageProps<{}> {
}

interface StudentActivityDetailReportState {
    isLoading: boolean;
    filterParams: Partial<ReportHeaderDTO>;
}

class StudentActivityDetailReport extends React.Component<StudentActivityDetailReportProps, StudentActivityDetailReportState> {
    private standardDataTableRef: DataTable<StudentActivityReportDTO>;
    // private pageSize: number = 7;

    constructor(props) {
        super(props);
        bindAllOfThis(this, StudentActivityDetailReport.prototype);

        this.state = {
            isLoading: false,
            filterParams: null
        };
    }

    private fetchData(requestState: ReportRequestDTO<ReportHeaderDTO>, checkEcho: () => boolean, callback: (response: TableResponseDTO<StudentActivityReportDTO>) => void): void {
        // Add custom filtering into the request
        requestState.filterData = this.state.filterParams as ReportHeaderDTO;

        // Debug, change the page size manually
        // console.warn("Setting page size", { prev: requestState.pageLength, curr: this.pageSize }); // JB - Remove this console.warn
        // requestState.pageLength = this.pageSize;

        // Dev Note: We can do Object.keys() as a shortcut because we are using NameOf for the columns which is tied to the backend models
        // requestState.filters = Object.keys(this.state.filterParams).map(key => ({ columnProp: key, filter: this.state.filterParams[key] as string }));

        // Show nothing in datatable if there are no filters, represented as {} from the reset function
        if (this.state.filterParams == null) {
            // Clear out the datatable as the clear button ends up here as well
            callback({ results: [], filteredCount: 0 } as TableResponseDTO<StudentActivityReportDTO>);
            return;
        }

        this.setState({ isLoading: true });
        ReportApiController.getStudentActivityReport(requestState)
            .then(results => {
                if (!checkEcho()) {
                    return;
                }

                this.setState({
                    isLoading: false
                });

                callback(results.data);
            });
    }

    private handleOnReset() {
        this.setState({ filterParams: null }, () => this.standardDataTableRef.refresh());
    }

    private handleOnSubmit(filterParams: Partial<ReportHeaderDTO>) {
        this.setState({ filterParams }, () => this.standardDataTableRef.refresh());
    }

    private customTableColumns(): DataTableColumnProps<StudentActivityReportDTO>[] {
        let columns: DataTableColumnProps<StudentActivityReportDTO>[] = [
            DataTable.AdvancedColumns.Text(<Translate id='common.headers.firstName' />, "firstName"),
            DataTable.AdvancedColumns.Text(<Translate id='common.headers.lastName' />, "lastName"),
            DataTable.BetterColumns.Custom(<Translate id='common.headers.currentGrade' />, "currentGradeName", {
                width: 150,
                // Show name but sort on Ids
                sorter: (a, b) => a.currentGradeId - b.currentGradeId
            }),

            DataTable.BetterColumns.Custom(<Translate id='common.headers.activityGrade' />, "activityGradeName", {
                width: 150,
                // Show name but sort on Ids
                sorter: (a, b) => a.activityGradeId - b.activityGradeId
            }),
            DataTable.AdvancedColumns.Text(<Translate id='common.headers.planet' />, "activityPlanetName"),
            DataTable.AdvancedColumns.Text(<Translate id='common.headers.activityType' />, "activityType"),
            DataTable.AdvancedColumns.Text(<Translate id='common.headers.activity' />, "activityName"),
            DataTable.AdvancedColumns.Date(<Translate id='common.headers.completedDate' />, "completedDate")
        ];

        return columns;
    }

    render() {
        return (
            <div className="admin-report student-activity-detail-report">
                <h2><Translate id="admin.sideNav.activityDetailReport" /></h2>
                <p>Activity Detail Report provides quick access to review the surveys and quizzes completed by students in your school. Choose one of the activities (Survey/Quiz), Reporting period and Grades to view the results.</p>
                <p>Report period is setup to use school years. School years start on August 1st and end on July 31st.</p>
                <p><Icon className="info-icon" type="info-circle" /> Click these icons for additional information.</p>
                <hr />
                <ReportHeader
                    reportingEvent={"Activity"}
                    defaultSchoolYears={"Previous 2"}
                    isLoading={false}
                    onSubmit={this.handleOnSubmit}
                    onReset={this.handleOnReset}
                />
                <DataTable
                    ref={ref => this.standardDataTableRef = ref}
                    serverSide={true}
                    tableProps={{
                        // UserId is not unique
                        // rowKey: NameOf<StudentActivityReportDTO>("userId"),
                        loading: this.state.isLoading,
                        pagination: {
                            defaultPageSize: 100,
                            showTotal: DataTable.StandardTotalsRenderer,
                            showSizeChanger: true,
                            pageSizeOptions: ["10", "25", "100", "9999"],
                        }
                    }}
                    columns={this.customTableColumns()}
                    data={[]}
                    fetchData={this.fetchData}
                    buttonBar={[
                        new DataTableButtonExport("Activity Detail Report")
                    ]}
                />
            </div>
        );
    }
}

export default StudentActivityDetailReport;



// WEBPACK FOOTER //
// ./src/pages/admin/reports/StudentActivityDetailReport.tsx